<div class="summary-wrapper flex flex-row">
  <div class="left-section  col-{{ leftSize }} ">
    <div class="side-container">
      <ng-content select="[title]"></ng-content>
      @if (!hasTitle) {
        @if (title !== "") {
          <h1>{{ title | translate }}</h1>
        }
      }
      <div>
        <ng-content select="[left]"></ng-content>
      </div>
    </div>
  </div>
  <div
    class="col-{{ rightSize }} right-section"
    [ngClass]="{ 'with-background': rightBackground }">
    <ng-content select="[right]"></ng-content>
    @if (!hasRight) {}
  </div>
</div>
